import * as React from 'react';
import Page from '../Page';
import AfrSummaryCore from '../AfrCore/AfrSummaryCore';
import { UserRoleEnum } from '../../redux/UserSlice';




const CR29Admin = (props: any) => {
    return (
        <React.Fragment>
            <Page>
                <AfrSummaryCore userRole={UserRoleEnum.EntityUser} dataSection="Admin" />
            </Page>
        </React.Fragment>
    );
}

export default CR29Admin;